import React, { useMemo, useState, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';

import ControldocDataTable from '../../../../controldoc/datatable';
import { aasmStateBadge } from '../../../helper';

const ComplianceBulkLoadActivityTable = (props) => {
  const {
    bulkLoad,
    complianceContextId,
    data: {
      aasmStateOptions,
      recurrenceOptions,
      riskLevelOptions,
    },
  } = props;

  const defaultRequestParams = { compliance_context_id: complianceContextId }

  const [selectedColumns, setSelectedColumns] = useState([]);
  const [selectedColumnKeys, setSelectedColumnKeys] = useState([]);

  useEffect(() => {
    if (tableColumns) {
      let visibleColumns = _.reject(tableColumns, {'hidden': true});

      setSelectedColumns(visibleColumns);
      setSelectedColumnKeys( _.map(visibleColumns, 'field') );
    }
  }, []);

  const onColumnSelectionChange = (e) => {
    const newSelectedColumnKeys = e.value;
    const filteredColumns = _.filter(tableColumns, (column) => _.includes(newSelectedColumnKeys, column.field));

    setSelectedColumns(filteredColumns);
    setSelectedColumnKeys(newSelectedColumnKeys);
  };

  const tableColumnsDefault = [
    {
      field: 'id',
      header: I18n.t('activerecord.attributes.compliance/bulk/load/activity.id'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese el ID de la actividad',
          filterrific: { search: 'search_by_id' }
        },
      sort: {
        enabled: true,
        filterrific: { sort: 'id' }
      }
    },
    {
      field: 'aasm_state',
      header: I18n.t('activerecord.attributes.compliance/bulk/load/activity.aasm_state.one'),
      body: (row) => aasmStateBadge(row?.aasm_state, 'compliance/bulk/load/activity') || I18n.t('no_entry'),
      filter: {
        enabled: true,
        inputType: 'simple_select',
        placeholder: 'Selecciona un estado',
        options: aasmStateOptions,
        filterrific: { search: 'by_aasm_state' },
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'aasm_state' }
      }
    },
    {
      field: 'created_by',
      header: I18n.t('activerecord.attributes.compliance/bulk/load/activity.created_by'),
      body: (row) => row?.created_by?.email || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Selecciona un creador',
        filterrific: { search: 'search_by_created_by_email' },
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'created_by_email' }
      }
    },
    {
      field: 'created_at',
      header: I18n.t('activerecord.attributes.compliance/bulk/load/activity.created_at'),
      body: (row) => moment(row?.created_at).format('DD-MM-YYYY HH:mm') || I18n.t('no_entry'),
      filter: {
        enabled: true,
        placeholder: 'Ingrese una fecha de creación',
        filterrific: { search: 'search_by_created_at' },
      },
      sort: {
        enabled: true,
        filterrific: { sort: 'created_at' }
      }
    },
  ];

  const tableColumnsActions = [
    {
      field: 'actions',
      header: I18n.t('actions.actions'),
      body: (row) =>
      <>
        {
          row.policy.show && (
            <Button color="primary" outline size="sm" className="ml-2" href={Routes.compliance_bulk_load_activity_path(row.hashid, { ...defaultRequestParams })}>
              {I18n.t('actions.show')}
            </Button>
          )
        }
      </>
    }
  ];

  const tableColumns = useMemo(() => {
    let columns = _.concat(
      tableColumnsDefault,
      tableColumnsActions
    )

    return _.compact(columns)
  }, [])

  return (
    <Row>
      <Col md="12">
        <ControldocDataTable
          columns={selectedColumns}
          configuration={{
            showDistributionListFilter: false,
            showGridlines: true,
            context: 'compliance',
            fetchRecords: {
              endpoint: Routes.compliance_bulk_load_activities_path,
              keyName: 'bulk_loads',
              defaultRequestParams: defaultRequestParams
            },
            columnSelectable: {
              enabled: true,
              columns: tableColumns,
              selection: selectedColumnKeys,
              onSelectionChange: onColumnSelectionChange,
            }
          }}
        />
      </Col>
    </Row>
  );
};

export default ComplianceBulkLoadActivityTable;